// Device image utility functions
export interface DeviceImageInfo {
  src: string;
  alt: string;
  width?: number;
  height?: number;
}

// Helper function to get device image based on device model only
export const getDeviceImage = (deviceModel?: string): DeviceImageInfo => {
  // Default fallback image
  const defaultImage: DeviceImageInfo = {
    src: '/assets/images/devices/default-monitor.svg',
    alt: 'Device Monitor',
    width: 24,
    height: 24
  };

  if (!deviceModel) {
    return defaultImage;
  }

  // Map device models to their respective images
  const deviceModelMap: { [key: string]: DeviceImageInfo } = {
    'Recobro v2': {
      src: '/assets/images/devices/recobro-monitor.png',
      alt: 'Recobro v2 Monitor',
      width: 24,
      height: 24
    },
    'Defigard Touch 7': {
      src: '/assets/images/devices/touch7-monitor.png',
      alt: 'Defigard Touch 7 Monitor',
      width: 24,
      height: 24
    },
    'APLC3': {
      src: '/assets/images/devices/aplc3-monitor.png',
      alt: 'APLC3 Monitor',
      width: 24,
      height: 24 
    }
  };

  // Direct model lookup
  if (deviceModelMap[deviceModel]) {
    return deviceModelMap[deviceModel];
  }

  return defaultImage;
};

// Helper function to get device image from alarm profiles/device menu if available
export const getDeviceImageFromMenu = (alarmProfiles: any, deviceType?: string, deviceModel?: string): DeviceImageInfo => {
  // If alarm profiles contain device menu with images
  if (alarmProfiles?.deviceMenu && deviceType && deviceModel) {
    const typeMenu = alarmProfiles.deviceMenu[deviceType];
    if (typeMenu && typeMenu[deviceModel]?.image) {
      return {
        src: typeMenu[deviceModel].image,
        alt: `${deviceType} ${deviceModel}`,
        width: 24,
        height: 24
      };
    }
  }

  // Fall back to the static mapping using only device model
  return getDeviceImage(deviceModel);
};